const storagePrefix = 'survey-answer-set-access:'
const accessHeader = 'X-Survey-Access-Token'

export function storeSurveyAccessToken (surveyAnswerSetId, token) {
  if (token) {
    window.localStorage.setItem(storagePrefix + surveyAnswerSetId, token)
  }
}

export function getSurveyAccessToken (surveyAnswerSetId) {
  return window.localStorage.getItem(storagePrefix + surveyAnswerSetId)
}

export function removeSurveyAccessToken (surveyAnswerSetId) {
  window.localStorage.removeItem(storagePrefix + surveyAnswerSetId)
}

export function surveyAccessConfig (surveyAnswerSetId, config = {}) {
  const token = getSurveyAccessToken(surveyAnswerSetId)

  if (!token) {
    return config
  }

  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      [accessHeader]: token
    }
  }
}

export function storedSurveyAccessTokens () {
  const tokens = []

  for (let index = 0; index < window.localStorage.length; index++) {
    const key = window.localStorage.key(index)
    if (key && key.startsWith(storagePrefix)) {
      tokens.push({
        surveyAnswerSetId: key.slice(storagePrefix.length),
        token: window.localStorage.getItem(key)
      })
    }
  }

  return tokens.filter(item => item.surveyAnswerSetId && item.token)
}
